<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h1>Subscriptions</h1>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h2>Yarlow Realtor Subscription</h2>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <p>You are currently subscribed as a:</p>
        <div v-if="premium">
          <p>Yarlow Realtor Subscription Pro</p>
          <p>That means you can share your custom branded Yarlow app with all of your current and future clients.</p>
          <p class="top-margin"><router-link to="/profile/realtor/checkout" class="price">$24.99</router-link> /month</p>
          <router-link tag="button" to="/profile/realtor/paymentinfo" class="btn btn-primary">Modify Subscription</router-link>
        </div>
        <div v-else>
          <p>Yarlow Realtor Free Subscription</p>
          <router-link tag="button" to="/profile/realtor/checkout" class="btn btn-primary">Subscribe</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('realtor', [
      'getPremium'
    ]),
    premium () {
      return this.getPremium
    }
  },
  mounted () {
    this.$global.gaEvent('realtorViewSubscriptions', 'navigation')
  }
}
</script>

<style scoped>
.bold-text {
  font-weight: bold;
  margin-bottom: 0;
}

.btn {
  margin-top: 0px !important;
}

.container {
  margin-bottom: 3rem !important;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.price {
  font-size: 1.5rem;
}

.product {
  padding-top: .5rem;
  padding-bottom: .5rem;
  padding-left: 2rem;
  padding-right: 2rem;
  border-radius: 10px;
}

.small-bottom-margin {
  margin-bottom: 1.5rem;
}

.sub-header {
  margin-bottom: 0;
  margin-top: 2rem;
}

.top-margin {
  margin-top: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/realtorProfile/RealtorSubscriptions.vue